import { noop } from "es-toolkit";
import { useEffect, useRef, useState } from "react";
export function useCountdown(
  expiryTimeStamp: number | null,
  onExpire: () => void = noop,
): number {
  const timerRef = useRef<ReturnType<typeof setInterval> | undefined>(
    undefined,
  );
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    if (expiryTimeStamp !== null) {
      const getTimeLeft = () =>
        Math.max((expiryTimeStamp - Date.now()) / 1000, 0);

      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      if (expiryTimeStamp === null) {
        return;
      }
      setTimeLeft(getTimeLeft());
      timerRef.current = setInterval(() => {
        setTimeLeft(getTimeLeft());
        if (getTimeLeft() === 0) {
          clearInterval(timerRef.current);
          onExpire();
        }
      }, 1000);

      return () => {
        clearInterval(timerRef.current);
      };
    }
  }, [expiryTimeStamp, onExpire, setTimeLeft]);

  return Math.ceil(timeLeft);
}
